// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"a239d40b","66":"a239d40b","416":"a239d40b","461":"a239d40b"}[chunkId] + ".chunk.css";
};